
import { InitRequestPayload } from "appworks/model/gameplay/requests/init-request-payload";
import { commsManager } from "appworks/server/comms-manager";

/** @deprecated Move to class function */
export function InitCommand() {
    return commsManager.request(new InitRequestPayload());
}
